import request from '@/utils/request';

// ---------------- 部门 ----------------
export const deptApi = {
  tree:   ()           => request.get('/sys/dept/tree'),
  create: (data)       => request.post('/sys/dept', data),
  update: (id, data)   => request.put(`/sys/dept/${id}`, data),
  remove: (id)         => request.delete(`/sys/dept/${id}`)
};

// ---------------- 岗位 ----------------
export const postApi = {
  page:    (params)    => request.get('/sys/post', { params }),
  options: ()          => request.get('/sys/post/options'),
  create:  (data)      => request.post('/sys/post', data),
  update:  (id, data)  => request.put(`/sys/post/${id}`, data),
  remove:  (id)        => request.delete(`/sys/post/${id}`)
};

// ---------------- 用户 ----------------
export const sysUserApi = {
  page:           (params)       => request.get('/sys/user', { params }),
  create:         (data)         => request.post('/sys/user', data),
  update:         (id, data)     => request.put(`/sys/user/${id}`, data),
  changeStatus:   (id, status)   => request.patch(`/sys/user/${id}/status`, null, { params: { status } }),
  resetPassword:  (id)           => request.post(`/sys/user/${id}/reset-password`),
  remove:         (id)           => request.delete(`/sys/user/${id}`),
  assignRoles:    (id, roleIds)  => request.put(`/sys/user/${id}/roles`, roleIds),
  getUserRoles:   (id)           => request.get(`/sys/user/${id}/roles`),
  assignProjects: (id, pids)     => request.put(`/sys/user/${id}/projects`, pids),
  getUserProjects:(id)           => request.get(`/sys/user/${id}/projects`)
};

// ---------------- 角色 ----------------
export const roleApi = {
  page:        (params)          => request.get('/sys/role', { params }),
  options:     ()                => request.get('/sys/role/options'),
  create:      (data)            => request.post('/sys/role', data),
  update:      (id, data)        => request.put(`/sys/role/${id}`, data),
  remove:      (id)              => request.delete(`/sys/role/${id}`),
  assignMenus: (id, keys)        => request.put(`/sys/role/${id}/menus`, keys),
  getMenus:    (id)              => request.get(`/sys/role/${id}/menus`),
  copy:        (id, data)        => request.post(`/sys/role/${id}/copy`, data)
};

// ---------------- 日志 ----------------
export const logApi = {
  loginLogs: (params) => request.get('/sys/log/login', { params }),
  operLogs:  (params) => request.get('/sys/log/oper', { params })
};

// ---------------- 公告 ----------------
export const noticeApi = {
  page:        (params)     => request.get('/sys/notice', { params }),
  create:      (data)       => request.post('/sys/notice', data),
  update:      (id, data)   => request.put(`/sys/notice/${id}`, data),
  remove:      (id)         => request.delete(`/sys/notice/${id}`),
  publish:     (id)         => request.post(`/sys/notice/${id}/publish`),
  markRead:    (id)         => request.post(`/sys/notice/${id}/read`),
  unreadCount: ()           => request.get('/sys/notice/unread-count')
};

// ---------------- 菜单 ----------------
export const menuApi = {
  tree:   ()           => request.get('/sys/menu/tree'),
  create: (data)       => request.post('/sys/menu', data),
  update: (id, data)   => request.put(`/sys/menu/${id}`, data),
  remove: (id)         => request.delete(`/sys/menu/${id}`)
};
